type ErrorMessagesKeys = 
  | 'DEFAULT_MESSAGE' 
  | '1000' 
  | '1001' 
  | '1002';

const ErrorMessageMap: Map<ErrorMessagesKeys, string> = new Map([
  [
    'DEFAULT_MESSAGE', 
    'Ocorreu um erro. Tente novamente mais tarde.'
  ],
  [
    '1000', 
    "O questionário já foi respondido."
  ],
  [
    '1001', 
    "O prazo para responder ao questionário expirou."
  ],
  [
    '1002', 
    "Os dados estão inválidos."
  ],
]);

export const getErrorMessage = (key: ErrorMessagesKeys): string => ErrorMessageMap.get(key) ?? ErrorMessageMap.get('DEFAULT_MESSAGE')!;

export const getErrorMessageFromCode = (code: string): string => {
  const _temp = code.split('.');
  const key = _temp[_temp.length - 1] as ErrorMessagesKeys;

  return ErrorMessageMap.get(key) ?? ErrorMessageMap.get('DEFAULT_MESSAGE')!;
};
